"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UIUtils = exports.KEYCODES = exports.Gender = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const KEYCODES = {
  TAB: "Tab",
  ZERO: 47,
  NINE: 57,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  NUM_PAD_ZERO: 96,
  NUM_PAD_NINE: 105
};
exports.KEYCODES = KEYCODES;
const Gender = {
  female: 0,
  male: 1
};
exports.Gender = Gender;

const replaceWithElement = text => (findBetween, replaceWith) => {
  return text.replace(/\*(.*?)\*/g, `<${replaceWith}>$1</${replaceWith}>`);
};

const formatTextWithLines = textToFormat => {
  let formattedText = "";

  if (textToFormat) {
    const splitText = textToFormat.split(/\n/);
    formattedText = splitText.map((line, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, line, /*#__PURE__*/_react.default.createElement("br", null)));
  }

  return formattedText;
};

const years = ["", "שנה עד שנתיים", "שנתיים עד 3 שנים", "3 עד 4 שנים", "4 עד 5 שנים", "יותר מ 5 שנים"];
const UIUtils = {
  isFullScreen: () => "standalone" in window.navigator && !window.navigator.standalone,
  focus: id => {
    const element = document.getElementById(id);

    if (element) {
      element.focus();
    }
  },
  ensureVisible: elementId => {
    const element = document.getElementById(elementId);

    if (element) {
      element.scrollIntoView();
    }
  },
  openOnEnter: (evt, func) => {
    let retVal = false;

    if (evt.keyCode === KEYCODES.ENTER) {
      func();
      retVal = true;
    }

    return retVal;
  },
  closeOnEsc: (evt, func) => {
    let retVal = false;

    if (evt.keyCode === KEYCODES.ESCAPE) {
      func();
      retVal = true;
    }

    return retVal;
  },
  focusOnTab: (evt, id) => {
    let retVal = false;

    if (evt.keyCode === KEYCODES.TAB) {
      UIUtils.focus(id);
      retVal = true;
    }

    return retVal;
  },
  hideScrollEx: () => document.body.style.overflow = "hidden",
  showScrollEx: () => document.body.style.overflow = "auto",
  hideScroll: () => document.body.style.overflowY = "hidden",
  showScroll: () => document.body.style.overflowY = "auto",
  numberToYears: (number, zeroStr) => number === 0 ? zeroStr : years[number],
  numberWithComma: number => ((number !== undefined) && (number !== null)) ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : "",
  breakLines: text => {
    let brokenText = text;

    if (typeof text === "object" && text.map) {
      brokenText = text.map(textLine => formatTextWithLines(textLine));
    } else if (typeof text === "string") {
      brokenText = formatTextWithLines(text);
    }

    return brokenText;
  },
  BBCode: text => {
    let convertedTexts = text.split(/\n/);
    convertedTexts = convertedTexts.map((line, index) => /*#__PURE__*/_react.default.createElement("span", {
      key: index,
      dangerouslySetInnerHTML: {
        __html: replaceWithElement(line)("*", "strong")
      }
    }));
    return convertedTexts.map((line, index) => /*#__PURE__*/_react.default.createElement(_react.Fragment, {
      key: index
    }, line, " ", index < convertedTexts.length && /*#__PURE__*/_react.default.createElement("br", null)));
  },
  isMale: (gender = Gender.male) => gender === Gender.male
};
exports.UIUtils = UIUtils;